import * as TYPES from './Report.types';

const initialState = {
  type: [],
  area: {},
  educationForms: [],
  assessmentsForms: [],
  enforcementForms: [],
  enforcementAgencies: [],
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPES.GET_CALC_POLY_SUCCESS: {
      const data = action?.result;
      const newTypes = data.reduce((acc, item) => {
        if (!item.polygons.length) return acc;
        const newType = {
          label: item.plural,
          value: item.plural,
          slug: item.slug,
        };
        acc.push(newType);
        return acc;
      }, []);

      const newArea = data.reduce((acc, item) => {
        if (!item.polygons.length) return acc;
        const newPolygons = item.polygons.map(({ name, id }) => ({ label: name, value: id, slug: item.slug }));
        acc[item.plural] = newPolygons;
        return acc;
      }, {});

      return {
        ...state,
        type: newTypes,
        area: newArea,
      };
    }

    case TYPES.GET_EDUCATION_FORMS_SUCCESS:
    case TYPES.GET_ASSESSMENTS_FORMS_SUCCESS:
    case TYPES.GET_ENFORCEMENT_FORMS_SUCCESS: {
      const data = action?.result?.data;
      const formOptions = data.map((elem) => ({
        value: elem.attributes.name,
        label: elem.attributes.name,
        key: elem.id,
      }));

      return { ...state, [action.visitName]: formOptions };
    }
    case TYPES.GET_ENFORCEMENT_AGENCIES_SUCCESS: {
      const data = action?.result?.data;
      const agenciesOptions = data.map((elem) => ({
        value: elem.attributes.name,
        label: elem.attributes.name,
        key: elem.id,
      }));
      return { ...state, enforcementAgencies: agenciesOptions };
    }

    case TYPES.RESET_CALC_POLY: {
      return {
        ...state,
      };
    }

    default:
      return state;
  }
};

export default reducer;
